import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

const ProgressValue = ({
  ProgressPercentage
}) => /*#__PURE__*/_jsx("div", {
  className: "progress-value",
  children: ProgressPercentage
});

ProgressValue.displayName = 'ProgressValue';
export default ProgressValue;